import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Items from "./components/Items";
import { Categories } from './components/Categories';
import ShowFullItem from "./components/ShowFullItem";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      currentItems: [],
      items: [
        {
          id: 1,
          title: "Цифрове Піаніно Yamaha P-225",
          img: "p225.webp",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "digital_piano",
          price: "750",
        },
        {
          id: 2,
          title: "Електрогітара Fender Player Stratocaster",
          img: "fender.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "guitar",
          price: "850",
        },
        {
          id: 3,
          title: "Рояль Steinway & Sons Model S",
          img: "models.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "royal",
          price: "65000",
        },
        {
          id: 4,
          title: "Акустичне піаніно Kawai K-300",
          img: "kawaik300.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "piano",
          price: "7000",
        },
        {
          id: 5,
          title: "Цифрове піаніно Roland FP-30X",
          img: "rolandfp30x.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "digital_piano",
          price: "700",
        },
        {
          id: 6,
          title: "Акустична гітара Yamaha F310",
          img: "yamahaf310.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "guitar",
          price: "180",
        },
        {
          id: 7,
          title: "Електричний Синтезатор Casio CT-S1",
          img: "casiocts1.avif",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "synthesizer",
          price: "250",
        },
        {
          id: 8,
          title: "Електронні барабани Alesis Nitro Max",
          img: "alesis.webp",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "drums",
          price: "450",
        },
        {
          id: 9,
          title: "Електрична Бас-гітара Ibanez GSR200",
          img: "ibanezgsr200.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "guitar",
          price: "280",
        },
        {
          id: 10,
          title: "Кабінетний рояль Yamaha GB1K",
          img: "gb1k.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "royal",
          price: "15000",
        },
        {
          id: 11,
          title: "Цифрове піаніно Casio Privia PX-S1100",
          img: "pxs1100.jpg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "digital_piano",
          price: "650",
        },
        {
          id: 12,
          title: "Акустичне піаніно Yamaha U1",
          img: "u1.jpeg",
          desc: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
          category: "piano",
          price: "11000",
        },
      ],
      ShowFullItem: false,
      fullItem: {}
    };
    this.state.currentItems = this.state.items;
    this.addToOrder = this.addToOrder.bind(this);
    this.deleteOrder = this.deleteOrder.bind(this);
    this.chooseCategory = this.chooseCategory.bind(this);
    this.onShowItem = this.onShowItem.bind(this);
  }

  render() {
    return (
      <div className="wrapper">
        <Header orders={this.state.orders} onDelete={this.deleteOrder} />
        <Categories chooseCategory={this.chooseCategory} />
        <Items
          onShowItem={this.onShowItem}
          items={this.state.currentItems}
          onAdd={this.addToOrder}
        />

        {this.state.ShowFullItem && (
          <ShowFullItem
            onAdd={this.addToOrder}
            onShowItem={this.onShowItem}
            item={this.state.fullItem}
          />
        )}
        <Footer />
      </div>
    );
  }

  onShowItem(item) { 
    this.setState({fullItem: item})
    this.setState({ ShowFullItem: !this.state.ShowFullItem })
  }

  chooseCategory(category) {
    if (category === 'all') {
      this.setState({ currentItems: this.state.items });
      return
    }

    this.setState({
      currentItems: this.state.items.filter(el => el.category === category)
    })
  }


  deleteOrder(id) {
    this.setState({ orders: this.state.orders.filter((el) => el.id !== id) });
  }

  addToOrder(item) {
    let isInArray = false;
    this.state.orders.forEach((element) => {
      if (element.id === item.id) {
        isInArray = true;
      }
    });

    if (!isInArray) this.setState({ orders: [...this.state.orders, item] });
  }
}

export default App;
